import { HttpClient, HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { AppConstants } from "src/app/app.constants";
import { catchError } from 'rxjs/operators';
import { Router } from '@angular/router';
import { ErrorHandlerService } from "src/app/core/services/error-handler.service";

@Injectable({
  providedIn: "root",
})
export class PatentInfoService {
  constructor(private http: HttpClient, private router: Router, private errorHandlerService: ErrorHandlerService) { }

  getSecondSection(ndaValue): Observable<any[]> {
    let paramsInput = new HttpParams();
    paramsInput = paramsInput.append("nda_number", ndaValue);
    return this.http.get<any[]>(
      `${AppConstants.API_ENDPOINT}${AppConstants.API.LIFECYCLE.LIFE_PATENT_INFORMATION}`,
      { params: paramsInput }
    ).pipe(catchError((error) => this.errorHandlerService.handleError(error)));
  }

  SendEmail(active_ingredient, brand_name, ndaValue, data): Observable<any[]> {
    let paramsInput = new HttpParams();
    paramsInput = paramsInput.append("nda_number", ndaValue);
    paramsInput = paramsInput.append("brand_name", brand_name);
    paramsInput = paramsInput.append("active_ingredient", active_ingredient);
    return this.http.put<any[]>(
      `${AppConstants.API_ENDPOINT1}${AppConstants.API.SENDEMAIL.PATENT_INFO}`,
      { data },
      { params: paramsInput }
    ).pipe(catchError((error) => this.errorHandlerService.handleError(error)));
  }

  getEditedData(active_ingredient, brand_name, ndaValue): Observable<any[]> {
    let paramsInput = new HttpParams();
    paramsInput = paramsInput.append("active_ingredient", active_ingredient);
    paramsInput = paramsInput.append("brand_name", brand_name);
    paramsInput = paramsInput.append("nda_number", ndaValue);
    return this.http.get<any[]>(
      `${AppConstants.API_ENDPOINT1}${AppConstants.API.GETEDITEDDATA.PATENT_INFO_EDITED}`,
      { params: paramsInput }
    ).pipe(catchError((error) => this.errorHandlerService.handleError(error)));
  }

  updateMoleculeData(data): Observable<any[]> {
    return this.http.put<any[]>(
      `${AppConstants.API_ENDPOINT1}${AppConstants.API.UPDATEMOLECULEDATA.PATENT_UPDATED_DATA}`,
      { data }
    ).pipe(catchError((error) => this.errorHandlerService.handleError(error)));
  }
}
